import React from 'react';

const About = () => (
  <div className="main-about-grid">
    <h2 className="about-h2">About</h2>
    <h3 className="about-h3 top-about">Presence gives weekly guidance for walking with God</h3>
    <p>
      Each week, the Presence App delivers <span style={{ fontWeight: 'bold' }}>1 or 2 exercises</span> to help
      cultivate your relationship with God and others.
    </p>
    <ul className="ul-about-grid">
      <li>
        <span style={{ fontWeight: 'bold' }}>You choose</span> the frequency.
      </li>
      <li>
        At the end of the week, rate the exercise (
        <span style={{ fontWeight: 'bold' }}>it’s easy—check “yes” or “no”</span>
        ).
      </li>
      <li>
        Presence saves <span style={{ fontWeight: 'bold' }}>only the exercises you like</span> to your personal tool
        kit.
      </li>
      <li>
        <span style={{ fontWeight: 'bold' }}>Based on your choices</span>, Presence continues to deliver regular,
        enjoyable, life-changing practices.
      </li>
    </ul>

    <h3 className="about-h3">Awareness vs. Activity</h3>
    <p className="about-left">
      Presence isn’t a devotional and it’s not a to-do list. It’s a tool for becoming more intentional in your awareness
      of God. Move past merely hoping to be more spiritual, and learn to train your senses to be more attuned to God in
      everyday life. Experience what the poet George Herbert called “heaven in ordinary” through the teaching you’ll
      find in Presence.
    </p>

    <h3 className="about-h3">What vs. How</h3>
    <p className="about-left">
      The Bible calls us to “abide in Christ,” to “walk with God,” and to “keep in step with the Spirit.” But how?
      Discover the answer through multiple exercises across 8 categories, encompassing a wide range of experiences,
      contexts, and interactions. These exercises go beyond Bible reading and prayer (though these are certainly
      included), tapping into all of your God-given senses in ways you may not have thought of.
    </p>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/Landing/About.js